import './site.css';

import { BOOKMARKLET_NAME, PASSWORD_HELPER_BOOKMARKLET } from './bookmarklet';
import { copyText } from './lib/clipboard';

function getElement<T extends Element>(selector: string): T {
  const element = document.querySelector<T>(selector);

  if (!element) {
    throw new Error(`未找到元素: ${selector}`);
  }

  return element;
}

function showToast(message: string, type: 'success' | 'error' = 'success'): void {
  const toast = getElement<HTMLElement>('#toast');
  toast.textContent = message;
  toast.className = `toast is-visible is-${type}`;

  window.setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 1800);
}

function runBookmarklet(): void {
  const source = decodeURIComponent(PASSWORD_HELPER_BOOKMARKLET.replace(/^javascript:/, ''));
  Function(source)();
}

function init(): void {
  const bookmarkletLink = getElement<HTMLAnchorElement>('#bookmarkletLink');
  const bookmarkletCode = getElement<HTMLTextAreaElement>('#bookmarkletCode');
  const copyBookmarkletBtn = getElement<HTMLButtonElement>('#copyBookmarkletBtn');
  const tryBookmarkletBtn = getElement<HTMLButtonElement>('#tryBookmarkletBtn');

  bookmarkletLink.href = PASSWORD_HELPER_BOOKMARKLET;
  bookmarkletLink.querySelector('span:last-child')!.textContent = BOOKMARKLET_NAME;
  bookmarkletCode.value = PASSWORD_HELPER_BOOKMARKLET;

  copyBookmarkletBtn.addEventListener('click', async () => {
    const result = await copyText(PASSWORD_HELPER_BOOKMARKLET);

    if (result.ok) {
      showToast('书签脚本已复制');
      return;
    }

    showToast('复制失败，请手动复制下方脚本', 'error');
  });

  tryBookmarkletBtn.addEventListener('click', () => {
    runBookmarklet();
    showToast('面板已在页面右上角打开');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
